import { Select } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledSelect = styled(Select)`
  cursor: pointer;
  height: 56px;
`
